import NavigationView from './navigationView';

const NavigationLayout = () => {
    return (
        <>
            <NavigationView />
        </>
    );
}

export default NavigationLayout;